import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-navigationless-layout',
  templateUrl: './navigationless-layout.component.html',
})
export class NavigationlessLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
